import getIsMobileSafari from "selectors/device/getIsMobileSafari";
import getIsSafari from "selectors/device/getIsSafari";
import getIsTablet from "selectors/device/getIsTablet";
import getIsUIWebView from "selectors/device/getIsUIWebView";
import getOsVersionFloat from "selectors/device/getOsVersionFloat";
import { createSelector } from "reselect";

export default createSelector(
  getIsMobileSafari,
  getIsSafari,
  getIsTablet,
  getIsUIWebView,
  getOsVersionFloat,
  (isMobileSafari, isSafari, isTablet, isUIWebView, osVersionFloat) => {
    if (isMobileSafari) {
      if (isTablet) {
        return true;
      }
      if (osVersionFloat && osVersionFloat >= 10) {
        // This is an iPhone on iOS >= 10. Only play HLS if this is not a UIWebView
        return !isUIWebView;
      }

      return false;
    }
    if (isSafari) {
      return true;
    }

    return false;
  },
);
